import { SxProps, Theme } from '@mui/material/styles';
import { columnFlex, rowFlex } from '../../lib/styles/commonStyles';
import colors from '../../lib/styles/colors';

export const rootGridSx = {
  marginBottom: '32px',
};

export const controlsRowSx = {
  marginBottom: '36px',
  ...rowFlex,
  justifyContent: 'space-between',
  height: '32px',
};

export const searchBarSx: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.mode === 'dark' ? theme.palette.grey[800] : '#F5F5F5',
  borderRadius: 1,
  width: '100%',
  maxWidth: '693px',
  '& .MuiInputBase-root': {
    height: '32px',
  },
});

export const sectionsGridSx = {
  gap: '40px',
  ...columnFlex,
};

export const headerActionsContainerSx = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

export const sectionTitleSx = {
  fontSize: '18px',
  fontWeight: 600,
  mb: 2,
};

export const cardsGridSx: SxProps<Theme> = (theme: Theme) => ({
  display: 'grid',
  gap: '16px',
  width: '100%',
  gridTemplateColumns: '1fr',
  // Keep the original responsive behavior: number of columns adapts to available width.
  // Cap at 3 columns for large+ screens.
  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(auto-fill, minmax(360px, 1fr))',
  },
  [theme.breakpoints.up('lg')]: {
    gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
  },
  '& > *': {
    maxWidth: 'none',
    boxSizing: 'border-box',
  },
});

export const dashboardCardSx: SxProps<Theme> = (theme: Theme) => ({
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' ? colors.reportCardHover.dark : colors.reportCardHover.light,
  },
  boxShadow: '0px 0px 0px 1px rgba(12, 26, 75, 0.03), 0px 3px 4px 0px rgba(50, 50, 71, 0.05)',
  minHeight: '106px',
  borderRadius: '16px',
  display: 'flex',
  cursor: 'pointer',
});

export const dashboardCardActionSx: SxProps<Theme> = (theme: Theme) => ({
  '&.MuiButtonBase-root': {
    '&:focus': {
      border: `2px solid ${theme.palette.secondary.main}`,
      backgroundColor: theme.palette.mode === 'dark' ? colors.reportCardHover.dark : colors.reportCardHover.light,
    },
  },
  '&.Mui-focusVisible .MuiCardActionArea-focusHighlight': {
    opacity: 0,
  },
  '&.MuiCardActionArea-root:hover .MuiCardActionArea-focusHighlight': {
    opacity: 0,
  },
  width: '100%',
});

export const viewToggleButtonSx = {
  alignItems: 'center',
  width: '117px',
  height: '40px',
  padding: '8px',
  marginTop: '16px',
  gap: '8px',
};

export const viewToggleTextSx: SxProps<Theme> = (theme: Theme) => ({
  fontWeight: 500,
  fontSize: '14px',
  color: theme.palette.primary.main,
});

export const dashboardCardTitleSx = {
  fontSize: '16px',
  fontWeight: 600,
};

export const dashboardCardDescriptionSx = {
  fontSize: '16px',
  fontWeight: 400,
};
